import React, { useState } from 'react';
import { colors } from '../utils/theme';
import { Lock, Eye, EyeOff, AlertCircle, CheckCircle, KeyRound } from 'lucide-react';

// Página pública de redefinição de senha — aberta pelo link do e-mail:
//   /resetar-senha?token=<token>
// Lê o token da URL, pede a nova senha e chama POST /api/auth/resetar-senha.
export default function ResetSenhaPage() {
  const params = new URLSearchParams(window.location.search);
  const token = params.get('token') || '';
  // convite=1: primeiro acesso do investidor (link do convite) — mesma mecânica, outro texto.
  const convite = params.get('convite') === '1';

  const [novaSenha, setNovaSenha] = useState('');
  const [confirmar, setConfirmar] = useState('');
  const [show, setShow] = useState(false);
  const [erro, setErro] = useState('');
  const [loading, setLoading] = useState(false);
  const [ok, setOk] = useState(false);

  const API = window.location.origin + '/api';

  const submit = async (e) => {
    e.preventDefault();
    if (!novaSenha || !confirmar) { setErro('Preencha os dois campos'); return; }
    if (novaSenha.length < 4) { setErro('A senha deve ter pelo menos 4 caracteres'); return; }
    if (novaSenha !== confirmar) { setErro('As senhas não conferem'); return; }
    setLoading(true); setErro('');
    try {
      const res = await fetch(`${API}/auth/resetar-senha`, {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ token, nova_senha: novaSenha }),
      });
      const data = await res.json();
      if (!res.ok) { setErro(data.error || 'Erro ao redefinir'); setLoading(false); return; }
      setOk(true);
      setTimeout(() => { window.location.href = '/'; }, 2500);
    } catch (err) { setErro('Erro de conexão com o servidor'); }
    setLoading(false);
  };

  const inputStyle = {
    width: '100%', padding: '12px 12px 12px 38px', borderRadius: 8,
    border: `1px solid ${colors.border}`, background: colors.bg,
    color: colors.text, fontSize: 14, outline: 'none', boxSizing: 'border-box',
  };

  return (
    <div style={{
      minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center',
      background: `linear-gradient(135deg, ${colors.bg} 0%, #1a1a2e 50%, ${colors.bgLight} 100%)`,
      fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
    }}>
      <div style={{
        width: 400, padding: 40, borderRadius: 16,
        background: colors.card, border: `1px solid ${colors.border}`,
        boxShadow: '0 20px 60px rgba(0,0,0,0.5)',
      }}>
        <div style={{ textAlign: 'center', marginBottom: 24 }}>
          <div style={{
            width: 56, height: 56, borderRadius: 14, background: `${colors.primary}22`,
            display: 'inline-flex', alignItems: 'center', justifyContent: 'center', marginBottom: 12,
          }}>
            <KeyRound size={28} color={colors.primary} />
          </div>
          <h1 style={{ color: colors.text, fontSize: 22, fontWeight: 700, margin: 0 }}>{convite ? 'Crie sua senha' : 'Nova senha'}</h1>
          <p style={{ color: colors.textDim, fontSize: 13, marginTop: 6 }}>Defina sua nova senha de acesso</p>
        </div>

        {!token && (
          <div style={{ background: `${colors.danger}18`, border: `1px solid ${colors.danger}55`, borderRadius: 8, padding: 14, color: colors.danger, fontSize: 13, display: 'flex', gap: 8 }}>
            <AlertCircle size={18} /> Link inválido (sem token). Solicite uma nova redefinição na tela de login.
          </div>
        )}

        {ok ? (
          <div style={{ background: `${colors.success}18`, border: `1px solid ${colors.success}55`, borderRadius: 8, padding: 16, color: colors.success, fontSize: 14, display: 'flex', gap: 8, alignItems: 'center' }}>
            <CheckCircle size={20} /> {convite ? 'Senha criada! Entre com seu e-mail e a senha que acabou de criar…' : 'Senha redefinida! Redirecionando para o login…'}
          </div>
        ) : token ? (
          <form onSubmit={submit}>
            {erro && (
              <div style={{ background: `${colors.danger}18`, border: `1px solid ${colors.danger}55`, borderRadius: 8, padding: '10px 12px', color: colors.danger, fontSize: 13, marginBottom: 14, display: 'flex', gap: 8 }}>
                <AlertCircle size={16} /> {erro}
              </div>
            )}
            <div style={{ position: 'relative', marginBottom: 14 }}>
              <Lock size={16} color={colors.textDim} style={{ position: 'absolute', left: 12, top: 14 }} />
              <input type={show ? 'text' : 'password'} value={novaSenha} onChange={e => setNovaSenha(e.target.value)}
                placeholder="Nova senha" autoFocus style={inputStyle} />
              <button type="button" onClick={() => setShow(s => !s)}
                style={{ position: 'absolute', right: 10, top: 11, background: 'none', border: 'none', cursor: 'pointer', color: colors.textDim }}>
                {show ? <EyeOff size={16} /> : <Eye size={16} />}
              </button>
            </div>
            <div style={{ position: 'relative', marginBottom: 18 }}>
              <Lock size={16} color={colors.textDim} style={{ position: 'absolute', left: 12, top: 14 }} />
              <input type={show ? 'text' : 'password'} value={confirmar} onChange={e => setConfirmar(e.target.value)}
                placeholder="Confirmar nova senha" style={inputStyle} />
            </div>
            <button type="submit" disabled={loading} style={{
              width: '100%', padding: 12, borderRadius: 8, border: 'none', cursor: loading ? 'default' : 'pointer',
              background: colors.primary, color: '#fff', fontSize: 15, fontWeight: 600, opacity: loading ? 0.7 : 1,
            }}>
              {loading ? 'Salvando…' : (convite ? 'Criar senha' : 'Redefinir senha')}
            </button>
          </form>
        ) : null}

        <div style={{ textAlign: 'center', marginTop: 18 }}>
          <a href="/" style={{ color: colors.textDim, fontSize: 13, textDecoration: 'none' }}>Voltar para o login</a>
        </div>
      </div>
    </div>
  );
}
